import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/styles/index.scss";
import App from "./App";

ReactDOM.render(<App />, document.getElementById("root"));
